import { DataTableActionBarAction } from "@/components/data-table/data-table-action-bar";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTitle, DialogContent, DialogHeader, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { useBulkPauseSubscription } from "@/lib/api/subscriptions";
import { Loader2, Pause } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface PauseSubscriptionsBulkActionModalProps {
    subscriptionIds: string[];
}
export const PauseSubscriptionsBulkActionModal = ({ subscriptionIds }: PauseSubscriptionsBulkActionModalProps) => {
    const { t } = useTranslation('subscriptions');
    const { mutate: pauseSubscriptionsMutation, isPending: isPausing } = useBulkPauseSubscription();
    const [isOpen, setIsOpen] = useState(false);

    const handleSubmit = () => {
        pauseSubscriptionsMutation({ subscriptionIds }, {
            onSettled: () => {
                setIsOpen(false);
            },
        });
    };

    const handleOpenChange = (open: boolean) => {
        if (!open && !isPausing) setIsOpen(false);
    };

    return (
        <>
            <DataTableActionBarAction
                tooltip={t('bulkActions.pause.tooltip')}
                isPending={isPausing}
                onClick={() => setIsOpen(true)}
            >
                <Pause className="mr-2 h-4 w-4" />
                {t('bulkActions.pause.button')}
            </DataTableActionBarAction>
            <Dialog open={isOpen} onOpenChange={handleOpenChange}>
                <DialogContent className="sm:max-w-[425px]">
                    <DialogHeader>
                        <DialogTitle>{t('bulkActions.pause.title')}</DialogTitle>
                        <DialogDescription>
                            {t('bulkActions.pause.confirmMessage', { count: subscriptionIds.length })}
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter>
                        <Button onClick={() => setIsOpen(false)} variant="outline">
                            {t('bulkActions.pause.cancel')}
                        </Button>
                        <Button onClick={handleSubmit} disabled={isPausing}>
                            {isPausing && <Loader2 className="size-4 animate-spin mr-2" />}
                            {t('bulkActions.pause.button')}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}